/**
 * @Injectable
 * Service that handles anthentication
 *
 */

import { Injectable, Output, EventEmitter } from '@angular/core';
import { Router, NavigationExtras } from '@angular/router';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';

import { CookieService } from 'angular2-cookie/core';
import { ToastyService } from 'ng2-toasty';

import { environment } from '../../../environments/environment';


@Injectable()

export class AuthService {

  @Output() getLoggedInName: EventEmitter<any> = new EventEmitter();

  redirectUrl: string = '/';
  token: any;

  // Set our navigation extras object
  // that passes on our global query params and fragment
  navigationExtras: NavigationExtras = {
    preserveQueryParams: true,
    preserveFragment: true
  };

  constructor(
    private http: Http,
    private router: Router,
    private cookieService: CookieService,
    private toastyService: ToastyService
  ) {}


  /**
   * Performs login attempt
   *
   * @param		  {Object}      sent form
   * @return		{Observable}
   */
  login(form: any, redirectUrl?: string): Observable<any> {
    return this.http.post(environment.apiUrl + 'member/login?include=user', form)
               .map(response => {
                 let json = response.json();
                 // Set cookie
                 this.cookieService.putObject('adapeiToken', { id: json.id, userId: json.userId }, { domain: environment.cookieDomain });

                 // Otherwise, if not redirect url, set curent url
                 if (redirectUrl)
                   this.redirectUrl = redirectUrl;
                 // If url set is login, erase it cause if will never leave the login page even if logged
                 if (this.redirectUrl.indexOf('login') != -1)
                   this.redirectUrl = '/';

                 this.getLoggedInName.emit(json.user.roles[0]);

                 // Redirect to original requested url
                 this.router.navigate([this.redirectUrl], this.navigationExtras);
                });
  }

  /**
   * Performs logout
   *
   * @return		{Observable}
   */
  logout(): Observable<any> {
    return this.http.post(environment.apiUrl + 'member/logout?access_token=' + this.token.id, {})
               .map(response => {
                 // If logout ok, reset token
                 this.tokenReset();
                })
               .catch(error => {
                 // If logout fails, reset token anyway and
                 this.tokenReset();
                 return Promise.reject(error.message || error);
               });
  }

  /**
   * Reset current token
   *
   * @return		void
   */
  tokenReset(): void {
    // Remove cookie
    this.cookieService.remove('adapeiToken', { domain: environment.cookieDomain });
    // Delete service token
    delete this.token;
    // Redirect to login page
    this.router.navigate(['/login'], this.navigationExtras);
  }

  /**
   * Reset current token
   *
   * @return		{String}    the optional url to redirect to
   * @return		{Object|Boolean}   The token if set, otherwise false
   */
  tokenGet(redirectUrl?: string): any|boolean {
    // Get token cookie
    this.token = this.cookieService.getObject('adapeiToken');
    // If set > return it
    if(this.token)
      return this.token;
    // Otherwise, if not redirect url, set curent url
    if(!redirectUrl)
      this.redirectUrl = this.router.url;
    // If url set is login, erase it cause if will never leave the login page even if logged
    if(this.redirectUrl.indexOf('login') != -1)
      this.redirectUrl = '/';
    // Redirect to login page
    //this.router.navigate(['/login']);
    // Return false
    return false;
  }


  forgotPwd(form: any): Observable<any> {
      return this.http.post(environment.apiUrl + 'member/reset?include=user', form)
          .map(response => {
              console.log(response);
              //let json = response.json();
              //console.log(json.user);

              //// Check if user is an administartor or a manager
              //if (json.user.roles && json.user.roles.length > 0 && json.user.roles[0].name != 'guest') {
              //    // Set cookie
              //    this.cookieService.putObject('adapeiToken', json);
              //    this.cookieService.putObject('userId', json.user.id);

              //    // Redirect to original requested url
              //    this.router.navigate([this.redirectUrl]);
              //} else {
              //    this.toastyService.error('Vous n\'avez pas les autorisations nécessaires.');
              //}
              return response;
          })
          .catch(error => {
              return Promise.reject(error.message || error);
          });
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/auth.service.ts